import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';

interface onSubmitFunction {
    (event: React.MouseEvent): void;
}

export interface PopupErrorProps {
    isUserError : boolean;
    title: string;
    explanation: string;
    message: string;
    okButtonText: string;
    telephoneText: string;
    telephoneNumber: string;
    telephoneHint: string;
    linkUrl: string;
    container: any;
    stayOnPage?: boolean;
    setFormValues?: any;

    email?: string;
    emailInfo? : string;
}

export const PopupError = (props: PopupErrorProps) => {
    
    return <Modal className={"form__popup form__popup-error" + (props.isUserError ? " form__popup-user-error" : "")} centered show={true} onHide={() => {}}>
        <Modal.Header className="form__popup-header">
            {props.isUserError ? <div className="form__popup-error-icon">
                <span className="icon icon-cross"></span>
            </div> : null}
            <Modal.Title>{props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="form__popup-content">            
            {!props.isUserError && <>
                    <div className="form__popup-content-text">
                        {props.explanation !== undefined && props.message !== '' ? ReactHtmlParser(props.message) : null}
                    </div>
                    <div className="form__popup-content-explanation">
                        {props.explanation !== undefined && props.explanation !== ''
                            ? ReactHtmlParser(props.explanation)
                            : null}
                    </div>
                </>
            }
            {!props.isUserError && props.telephoneNumber !== undefined &&
            props.telephoneNumber !== '' &&
            props.telephoneText !== undefined &&
            props.telephoneText !== '' &&
            props.telephoneHint !== undefined &&
            props.telephoneHint !== '' ? (
                <ul className="content-featured-list__list">
                    <li className="icon icon-phone">
                        <a
                            className="content-featured-list__list-link personenoverzicht__persoon-contact-detail"
                            title={props.telephoneText}
                            href={"tel:" + props.telephoneNumber}
                        >
                            {props.telephoneText}
                            <span className="content-featured-list__list-link-subtext">
                                {props.telephoneHint}
                            </span>
                        </a>
                    </li>
                </ul>
            ) : null}
            {!props.isUserError && props.email !== undefined &&
            props.email !== '' &&
            props.emailInfo !== undefined &&
            props.emailInfo !== '' ? (
                <ul className="content-featured-list__list">
                    <li className="icon icon-mail">
                        <a
                            className="content-featured-list__list-link personenoverzicht__persoon-contact-detail"
                            title={props.email}
                            href={"mailto:" + props.email}
                        >
                            {props.email}
                            <span className="content-featured-list__list-link-subtext">
                                {props.emailInfo}
                            </span>
                        </a>
                    </li>
                </ul>
            ) : null}
        </Modal.Body>
        <Modal.Footer
            onClick={() => {
                if (props.container) {
                    props.container.setState({
                        isShowPostDataError: false,
                        isShowTooBigDataError : false,
                        isUserError: false
                    });
                }
                if (props.setFormValues) {
                    props.setFormValues('formGetApiError', false);
                }
            }}
            className="form__popup-buttons"
        >
            {props.stayOnPage === true ? 
                <span className={props.isUserError ? "btn btn-outline-primary" : "btn btn-primary"}>{props.okButtonText}</span> :
                <Link to={props.linkUrl} className={props.isUserError ? "btn btn-outline-primary" : "btn btn-primary"}>
                    {props.okButtonText}
                </Link>
            }
        </Modal.Footer>
    </Modal>;
};

